import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ITEM_REVENUE_CATEGORY } from 'src/app/helpers/item-revenue.helper';
import { LENS_TYPES } from 'src/app/helpers/lenses.helper';
import { CompanyLenses } from 'src/app/models/company-lenses.model';
import { ItemDetailsRequest } from 'src/app/models/requests/item-details-request.model';
import { CartManagerService } from 'src/app/services/local/cart-manager.service';

@Component({
    selector: 'app-guided-opt-modal',
    templateUrl: './guided-opt-modal.component.html',
    styleUrls: ['./guided-opt-modal.component.scss'],
    standalone: false
})
export class GuidedOptModalComponent implements OnInit {

  @Input() lensType: LENS_TYPES = LENS_TYPES.singleVision;
  @Input() lenses: CompanyLenses[] = [];
  @Input() isSingleVisionRecommended: boolean = false;

  public LENS_TYPES = LENS_TYPES;
  public svLenses: CompanyLenses[] = [];
  public bfProgLenses: CompanyLenses[] = [];
   
  constructor(public activeModal: NgbActiveModal,
              private _router: Router,
              private _cartManagerService: CartManagerService) { }

  ngOnInit(): void {
    this.filterLenses();
  }
    
  filterLenses() {
    this.svLenses = this.lenses.filter(l => l.visionType == LENS_TYPES.singleVision);
    this.bfProgLenses = this.lenses.filter(l => l.visionType == LENS_TYPES.bifocal || l.visionType == LENS_TYPES.progressive);
  }

  lensTypeSwitch(newLensType: any) {
    this.lensType = newLensType;
  }

  addLensToCart(selectedLens: any) {
    const cartItemDetail : ItemDetailsRequest = {
      id: selectedLens.lensId,
      itemType: ITEM_REVENUE_CATEGORY.lenses,
      itemDescription: selectedLens.lensDescription
    };
    this._cartManagerService.updateTempCartItemDetail(cartItemDetail);
    this.activeModal.close();
    if (this.lensType == LENS_TYPES.singleVision) {
      this._router.navigate(['/lens-selection/prescription/single-vision']);
    } else {
      this._router.navigate(['/lens-selection/prescription/bifocal-progressive']);
    }
  }

}
